const labelWithRequiredIndicator = ({
  isRequired,
  label,
}: {
  isRequired?: boolean
  label?: string
}): string | undefined =>
  isRequired && label
    ? label.concat('<span aria-hidden="true">&nbsp;*</span>')
    : label

export default labelWithRequiredIndicator
